<template>
  <header class="flex items-center justify-between ">
    <div class="flex items-center justify-start mb-5">
      <img src="@/assets/img/logo-ravenol.png" class="w-48" />
    </div>
    <div class="text-right"><vehicle-info class="rounded-lg" :show-vehicle-image="false" /></div>
  </header>
</template>

<script>
import VehicleInfo from '@/components/VehicleInfo.vue';
export default {
  components: { VehicleInfo }
};
</script>

<style scoped lang="postcss">
.pipe {
  @apply h-8 bg-gray-300 block mx-4;
  width: 3px;
  transform: skewX(-16deg);
}
</style>
